/*=========================================================================================
  File Name: moduleTransaction.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleTransactionState.js";
import mutations from "./moduleTransactionMutations.js";
import actions from "./moduleTransactionActions.js";
import getters from "./moduleTransactionGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
